<template>
  <div>
    <!-- title -->
    <div class="header">
      <h1 class="page-title">外发待处理订单</h1>
    </div>
    <el-card class="box-card card">
      <div class="main clearfix">
        <span class="msg">
          一共
          <i>{{totalNum}}</i>
          条订单
        </span>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          max-height="500"
          v-loading="loading1"
        >
          <el-table-column :resizable="false" type="index" label="序号"></el-table-column>
          <el-table-column :resizable="false" prop="file" label="文件名" width="358"></el-table-column>
          <el-table-column :resizable="false" prop="product_name" label="产品种类" width="120"></el-table-column>
          <el-table-column :resizable="false" prop="title" label="规格" width="180"></el-table-column>
          <el-table-column :resizable="false" prop="kuanshu" label="款数" width="60"></el-table-column>
          <el-table-column :resizable="false" label="价格" width="120">
            <template slot-scope="scope">{{scope.row.craft_price + scope.row.goods_price}}</template>
          </el-table-column>
          <el-table-column :resizable="false" prop="product_weight" label="重量(kg)" width="90"></el-table-column>
          <el-table-column :resizable="false" prop="shipping_fee" label="运费" width="80"></el-table-column>
          <el-table-column :resizable="false" label="总计" width="120">
            <template slot-scope="scope">{{scope.row.shipping_fee+scope.row.total_price}}</template>
          </el-table-column>
          <el-table-column :resizable="false" prop="shopping_name" label="收货信息" width="300">
            <template slot-scope="scope">
              <p>收 货 人：{{scope.row.shopping_name}}</p>
              <p>配送地址：{{scope.row.address_text}}</p>
              <p>详细地址：{{scope.row.address_query}}</p>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="danger" @click="delCar(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <button @click="goZhifu" class="sy_zf" v-show="tableData.length">去支付</button>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      totalNum: 0,
      loading1: true
    }
  },
  created() {
    this.queryOrderList()
  },

  methods: {
    // 删除订单
    async delCar(id) {
      let param = new URLSearchParams()
      param.append('ids', id)
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/car/delcar',
        data: param
      })
      if (res.code == 1) {
        this.$confirm('删除成功', '提示')
      }
      this.queryOrderList()
    },
    //批量下单列表
    async queryOrderList() {
      this.loading1 = true
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      param.append('cartype', 3)
      const { data: result } = await this.$http.post('api/car/index', param)
      this.loading1 = false
      if (result.data) {
        this.tableData = result.data.reverse()
        this.totalNum = this.tableData.length
      }
    },
    goZhifu() {
      window.sessionStorage.setItem('cartype', 3)
      this.$router.push('/paymentOrder')
    }
  }
}
</script>
<style lang="less" scoped>
.header {
  margin-bottom: 20px;
  .page-title {
    font-size: 24px;
  }
}
.card {
  min-height: 700px;
  .cell {
    p {
      text-align: left;
    }
  }
  .msg {
    float: right;
    font-size: 18px;
    margin: 0 15px 15px 0;
    i {
      color: #e83030;
    }
  }
  .sy_zf {
    float: right;
    margin: 50px 50px 0 0;
    width: 200px;
    height: 50px;
    font-size: 18px;
    color: #fff;
    background-color: #a77c5a;
    cursor: pointer;
  }
}
</style>